import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "footer__logos" }
const _hoisted_3 = { class: "row justify-content-center align-items-center" }
const _hoisted_4 = { class: "col-6 col-md-6 col-xl-auto text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-6 col-md-6 col-xl-auto text-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-6 col-md-6 col-xl-auto text-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-6 col-md-6 col-xl-auto text-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 col-md-auto text-center text-md-start" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block col-md" }, null, -1)
const _hoisted_16 = { class: "col-12 col-md-auto text-center text-md-start" }
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass({ 'pd-btn': _ctx.hasKlimaheldSection })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: `${_ctx.themeUri}/assets/img/Stadt_Castrop-Rauxel_Logo.jpg`,
              alt: "Stadt_Castrop-Rauxel_Logo"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: `${_ctx.themeUri}/assets/img/Stadtwerke_Castrop-Rauxel-Logo.jpg`,
              alt: "Stadtwerke_Castrop-Rauxel-Logo"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: `${_ctx.themeUri}/assets/img/logo-euv-website.jpg`,
              alt: "EVUl-Logo"
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: `${_ctx.themeUri}/assets/img/logo-verbraucherzentrale-website.jpg`,
              alt: "Verbraucherzentrale-Logo"
            }, null, 8, _hoisted_11)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuLeft, (menuItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menuItem.url
                }, [
                  _createVNode(_component_IoRouterLink, {
                    "link-url": menuItem.url,
                    "link-target": menuItem.target,
                    "link-title": menuItem.titleAttr
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: menuItem.title
                      }, null, 8, _hoisted_14)
                    ]),
                    _: 2
                  }, 1032, ["link-url", "link-target", "link-title"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuRight, (menuItem) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menuItem.url
                }, [
                  _createVNode(_component_IoRouterLink, {
                    "link-url": menuItem.url,
                    "link-target": menuItem.target,
                    "link-title": menuItem.titleAttr
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: menuItem.title
                      }, null, 8, _hoisted_17)
                    ]),
                    _: 2
                  }, 1032, ["link-url", "link-target", "link-title"])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 2))
}